"use strict";
/* eslint-disable quote-props */
/* eslint-disable quotes */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated Use usePermissionCheck() react hook or HasPermission() HOC in the frontend, or ctx.authorization.requesterHasPermission in the backend.
 * @example
 * // Permission Checks should be migrated to the new functions:
 * // Use usePermissionCheck() react hook or HasPermission() HOC in the frontend, or ctx.authorization.requesterHasPermission in the backend.
 * // e.g. checkPermission(loginUser.permissions, permissionTypes.GRADE_VIEW_OWN) or authorization.requesterHasLegacyPermissions(requester, [permissionTypes.GRADE_VIEW_OWN]) should become:
 * // Frontend:
 * const { isPermitted, loading } = usePermissionCheck({
 *   action: PermissionAction.View,
 *   resourceType: PermisionResourceType.Grade,
 *   resource: PermissionResourceAlias.Own
 * }, []);
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.View,
 *   resourceType: PermisionResourceType.Grade,
 *   resource: PermissionResourceAlias.Own
 * }, []);
 * export default withPermission(MyComponent);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.View,
 *   resourceType: PermisionResourceType.Grade,
 *   resource: PermissionResourceAlias.Own
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.View,
 *   resourceType: PermisionResourceType.Grade,
 *   resource: PermissionResourceAlias.Own
 * }, []);
 */
const permissions = {
    CREATE_PACKAGE: 'CREATE_PACKAGE',
    VIEW_PACKAGE: 'VIEW_PACKAGE',
    EDIT_PACKAGE: 'EDIT_PACKAGE',
    CREATE_PACKAGE_SUBJECT: 'CREATE_PACKAGE_SUBJECT',
    EDIT_PACKAGE_SUBJECT: 'EDIT_PACKAGE_SUBJECT',
    EDIT_SUBJECT_TUTOR: 'EDIT_SUBJECT_TUTOR',
    VIEW_CALENDAR: 'VIEW_CALENDAR',
    VIEW_ADMIN_CALENDAR: 'VIEW_ADMIN_CALENDAR',
    VIEW_MY_SUBJECTS: 'VIEW_MY_SUBJECTS',
    VIEW_MY_STUDENTS: 'VIEW_MY_STUDENTS',
    VIEW_OUR_PEOPLE: 'VIEW_OUR_PEOPLE',
    DEACTIVATE_USER: 'DEACTIVATE_USER',
    EDIT_PROFILE_TUTOR_SUBJECT: 'EDIT_PROFILE_TUTOR_SUBJECT',
    VIEW_MY_TEAM: 'VIEW_MY_TEAM',
    VIEW_ALL_USERS: 'VIEW_ALL_USERS',
    VIEW_STUDENT: 'VIEW_STUDENT',
    VIEW_TUTOR: 'VIEW_TUTOR',
    VIEW_CASE_MANAGER: 'VIEW_CASE_MANAGER',
    VIEW_HEAD_TUTOR: 'VIEW_HEAD_TUTOR',
    VIEW_OPERATIONAL_SUPPORT: 'VIEW_OPERATIONAL_SUPPORT',
    VIEW_STRATEGIST: 'VIEW_STRATEGIST',
    VIEW_SUPER_ADMIN: 'VIEW_SUPER_ADMIN',
    VIEW_ABOUT_TAB: 'VIEW_ABOUT_TAB',
    VIEW_PACKAGE_TAB: 'VIEW_PACKAGE_TAB',
    VIEW_STUDENTS_TAB: 'VIEW_STUDENTS_TAB',
    VIEW_SUBJECTS_TAB: 'VIEW_SUBJECTS_TAB',
    VIEW_AVAILABILITY_TAB: 'VIEW_AVAILABILITY_TAB',
    CREATE_USER: 'CREATE_USER',
    EDIT_USER_ACCOUNT: 'EDIT_USER_ACCOUNT',
    EDIT_USER_RELATIONSHIP: 'EDIT_USER_RELATIONSHIP',
    VIEW_CONTRACT: 'VIEW_CONTRACT',
    VIEW_AVAILABILITY: 'VIEW_AVAILABILITY',
    CREATE_STUDENT: 'CREATE_STUDENT',
    CREATE_TUTOR: 'CREATE_TUTOR',
    CREATE_HEAD_TUTOR: 'CREATE_HEAD_TUTOR',
    CREATE_STRATEGIST: 'CREATE_STRATEGIST',
    CREATE_OPERATIONAL_SUPPORT: 'CREATE_OPERATIONAL_SUPPORT',
    CREATE_CASE_MANAGER: 'CREATE_CASE_MANAGER',
    CREATE_SUPER_ADMIN: 'CREATE_SUPER_ADMIN',
    VIEW_LESSON_DETAILS: 'VIEW_LESSON_DETAILS',
    VIEW_LESSON_LIST: 'VIEW_LESSON_LIST',
    VIEW_BILLING_TAB: 'VIEW_BILLING_TAB',
    EDIT_BILLING_TAB: 'EDIT_BILLING_TAB',
    VIEW_SESSION_REPORT: 'VIEW_SESSION_REPORT',
    VIEW_INVOICE: 'VIEW_INVOICE',
    VIEW_ALL_LESSON_REPORTS: 'VIEW_ALL_LESSON_REPORTS',
    CREATE_ROADMAP: 'CREATE_ROADMAP',
    DELETE_ROADMAP: 'DELETE_ROADMAP',
    EDIT_ROADMAP: 'EDIT_ROADMAP',
    VIEW_ROADMAP: 'VIEW_ROADMAP',
    EDIT_ROADMAP_SUBTASK: 'EDIT_ROADMAP_SUBTASK',
    VIEW_INVOICES: 'VIEW_INVOICES',
    EDIT_PROFILE_TUTOR_BIO: 'EDIT_PROFILE_TUTOR_BIO',
    MARK_INVOICE_AS_PAID: 'MARK_INVOICE_AS_PAID',
    SUBMIT_INVOICE: 'SUBMIT_INVOICE',
    CREATE_ROADMAP_TEMPLATE: 'CREATE_ROADMAP_TEMPLATE',
    DEVELOPER: 'DEVELOPER',
    VIEW_TUTOR_INFO_NOTES: 'VIEW_TUTOR_INFO_NOTES',
    EDIT_TUTOR_INFO_NOTES: 'EDIT_TUTOR_INFO_NOTES',
    VIEW_STUDENT_INFO_NOTES: 'VIEW_STUDENT_INFO_NOTES',
    EDIT_STUDENT_INFO_NOTES: 'EDIT_STUDENT_INFO_NOTES',
    CREATE_ACCOUNTS: 'CREATE_ACCOUNTS',
    VIEW_ACCOUNTS: 'VIEW_ACCOUNTS',
    VIEW_MESSAGES: 'VIEW_MESSAGES',
    FEEDBACK_TO_STRATEGIST: 'FEEDBACK_TO_STRATEGIST',
    DELETE_INVOICE: 'DELETE_INVOICE',
    CREATE_THREAD_CONTRACT: 'CREATE_THREAD_CONTRACT',
    CREATE_THREAD_RELATIONSHIP: 'CREATE_THREAD_RELATIONSHIP',
    CREATE_THREAD_ROLE_STUDENT: 'CREATE_THREAD_ROLE_STUDENT',
    CREATE_THREAD_ROLE_TUTOR: 'CREATE_THREAD_ROLE_TUTOR',
    CREATE_THREAD_ROLE_HEAD_TUTOR: 'CREATE_THREAD_ROLE_HEAD_TUTOR',
    CREATE_THREAD_ROLE_STRATEGIST: 'CREATE_THREAD_ROLE_STRATEGIST',
    CREATE_THREAD_ROLE_ACCOUNT: 'CREATE_THREAD_ROLE_ACCOUNT',
    CREATE_THREAD_ROLE_CASE_MANAGER: 'CREATE_THREAD_ROLE_CASE_MANAGER',
    CREATE_THREAD_ROLE_OPERATIONAL_SUPPORT: 'CREATE_THREAD_ROLE_OPERATIONAL_SUPPORT',
    CREATE_THREAD_ROLE_SUPER_ADMIN: 'CREATE_THREAD_ROLE_SUPER_ADMIN',
    VIEW_ADMISSION_RESULTS: 'VIEW_ADMISSION_RESULTS',
    EDIT_ADMISSION_RESULTS: 'EDIT_ADMISSION_RESULTS',
    CREATE_ADMISSION_RESULTS: 'CREATE_ADMISSION_RESULTS',
    DELETE_ADMISSION_RESULTS: 'DELETE_ADMISSION_RESULTS',
    VIEW_ALL_APPLICATIONS: 'VIEW_ALL_APPLICATIONS',
    VIEW_OWN_APPLICATIONS: 'VIEW_OWN_APPLICATIONS',
    EDIT_ALL_APPLICATIONS: 'EDIT_ALL_APPLICATIONS',
    EDIT_OWN_APPLICATIONS: 'EDIT_OWN_APPLICATIONS',
    DELETE_ROADMAP_ELEMENTS: 'DELETE_ROADMAP_ELEMENTS',
    HEXACO_VIEW_ALL: 'HEXACO_VIEW_ALL',
    HEXACO_EDIT_ALL: 'HEXACO_EDIT_ALL',
    HEXACO_VIEW_OWN: 'HEXACO_VIEW_OWN',
    HEXACO_EDIT_OWN: 'HEXACO_EDIT_OWN',
    EDIT_EXAM_PREP_AVAILABILITY: 'EDIT_EXAM_PREP_AVAILABILITY',
    RESET_EXAM_PREP: 'RESET_EXAM_PREP',
    VIEW_EXAM_PREP: 'VIEW_EXAM_PREP',
    VIEW_ANSWER_SHEET: 'VIEW_ANSWER_SHEET',
    VIEW_EXAM_PREP_TAB: 'VIEW_EXAM_PREP_TAB',
    VIEW_PROGRESS_REPORT_TAB: 'VIEW_PROGRESS_REPORT_TAB',
    EDIT_PROGRESS_REPORT: 'EDIT_PROGRESS_REPORT',
    FILE_VIEW_ALL_STUDENTS: 'FILE_VIEW_ALL_STUDENTS',
    FILE_VIEW_ALL_TUTORS: 'FILE_VIEW_ALL_TUTORS',
    FILE_VIEW_OWN: 'FILE_VIEW_OWN',
    FILE_EDIT_ALL_STUDENTS: 'FILE_EDIT_ALL_STUDENTS',
    FILE_EDIT_ALL_TUTORS: 'FILE_EDIT_ALL_TUTORS',
    FILE_EDIT_OWN: 'FILE_EDIT_OWN',
    GRADE_VIEW_ALL: 'GRADE_VIEW_ALL',
    GRADE_VIEW_OWN: 'GRADE_VIEW_OWN',
    GRADE_EDIT_ALL: 'GRADE_EDIT_ALL',
    GRADE_EDIT_OWN: 'GRADE_EDIT_OWN',
    SPY_SEND_MESSAGE: 'SPY_SEND_MESSAGE',
    CRUD_BOOKING_ON_BEHALF: 'CRUD_BOOKING_ON_BEHALF',
    VIEW_OWN_TASKS: 'VIEW_OWN_TASKS',
    VIEW_ALL_TASKS: 'VIEW_ALL_TASKS',
    EDIT_OWN_TASKS: 'EDIT_OWN_TASKS',
    EDIT_ALL_TASKS: 'EDIT_ALL_TASKS',
    DELETE_OWN_TASKS: 'DELETE_OWN_TASKS',
    DELETE_ALL_TASKS: 'DELETE_ALL_TASKS',
    VIEW_ALL_ECL: 'VIEW_ALL_ECL',
    VIEW_OWN_ECL: 'VIEW_OWN_ECL',
    EDIT_ALL_ECL: 'EDIT_ALL_ECL',
    EDIT_OWN_ECL: 'EDIT_OWN_ECL',
    VIEW_HUB_LINK: 'VIEW_HUB_LINK',
    VIEW_ASK_LINK: 'VIEW_ASK_LINK',
    KEY_CONTACT_CREATE_ALL: 'KEY_CONTACT_CREATE_ALL',
    KEY_CONTACT_CREATE_OWN: 'KEY_CONTACT_CREATE_OWN',
    VIEW_BOOKING_ADMINISTRATOR: 'VIEW_BOOKING_ADMINISTRATOR',
    CREATE_BOOKING_ADMINISTRATOR: 'CREATE_BOOKING_ADMINISTRATOR',
    EDIT_USER_AUTH: 'EDIT_USER_AUTH',
    'AGENDA:EDIT': 'AGENDA:EDIT',
    'AGENDA:VIEW': 'AGENDA:VIEW',
    'AGENDA:DELETE': 'AGENDA:DELETE',
    KEY_CONTACT_VIEW_ALL: 'KEY_CONTACT_VIEW_ALL',
    KEY_CONTACT_VIEW_OWN: 'KEY_CONTACT_VIEW_OWN',
    'SESSION_NOTES:VIEW': 'SESSION_NOTES:VIEW',
    'SESSION_NOTES:EDIT': 'SESSION_NOTES:EDIT',
    'SESSION_SUMMARY:SEND_EMAIL': 'SESSION_SUMMARY:SEND_EMAIL',
    VIEW_ALPHA_TESTER: 'VIEW_ALPHA_TESTER',
    CREATE_ALPHA_TESTER: 'CREATE_ALPHA_TESTER',
    VIEW_BETA_TESTER: 'VIEW_BETA_TESTER',
    CREATE_BETA_TESTER: 'CREATE_BETA_TESTER',
    'ZOOM_MEETING:EDIT': 'ZOOM_MEETING:EDIT',
    'ZOOM_USER:EDIT': 'ZOOM_USER:EDIT',
    'EXTERNAL_STUDENT:EDIT': 'EXTERNAL_STUDENT:EDIT',
    'EXTERNAL_STUDENT:VIEW': 'EXTERNAL_STUDENT:VIEW',
    'SYSTEM_OPERATOR:EDIT': 'SYSTEM_OPERATOR:EDIT',
    'SYSTEM_OPERATOR:VIEW': 'SYSTEM_OPERATOR:VIEW',
    'USER_PROFILE:EDIT_ALL': 'USER_PROFILE:EDIT_ALL',
    'CRIMSON_CONNECT_LINK:VIEW': 'CRIMSON_CONNECT_LINK:VIEW',
    'RECORDING_CONSENT:EDIT': 'RECORDING_CONSENT:EDIT',
    'ECL_SEARCH_LINK:VIEW': 'ECL_SEARCH_LINK:VIEW',
    'USER_EDUCO_RELATIONSHIP:EDIT': 'USER_EDUCO_RELATIONSHIP:EDIT',
    'USER_STRATEGIST_RELATIONSHIP:EDIT': 'USER_STRATEGIST_RELATIONSHIP:EDIT',
    'USER_HEAD_TUTOR_RELATIONSHIP:EDIT': 'USER_HEAD_TUTOR_RELATIONSHIP:EDIT',
    'STUDENT_TYPE:EDIT': 'STUDENT_TYPE:EDIT',
    'STUDENT_TYPE:VIEW': 'STUDENT_TYPE:VIEW',
    VIEW_RATING_TAB: 'RATING_TAB:VIEW',
    VIEW_RATING_SENTIMENT: 'RATING_SENTIMENT:VIEW',
    'ALERT:CREATE': 'ALERT:CREATE',
    'ALERT:VIEW': 'ALERT:VIEW',
    'UNSUBSCRIBE_LINK:VIEW': 'UNSUBSCRIBE_LINK:VIEW',
    'SUBSCRIPTION_USER:EDIT': 'SUBSCRIPTION_USER:EDIT',
    'SUBSCRIPTION_USER:VIEW': 'SUBSCRIPTION_USER:VIEW',
    'SESSION_RESOURCE:CREATE': 'SESSION_RESOURCE:CREATE',
    'SESSION_RESOURCE:EDIT': 'SESSION_RESOURCE:EDIT',
    'SESSION_RESOURCE:DELETE': 'SESSION_RESOURCE:DELETE',
    'RCT_EXPERIMENT_CONSENT:VIEW_ALL': 'RCT_EXPERIMENT_CONSENT:VIEW_ALL',
    'RCT_EXPERIMENT_CONSENT:EDIT_ALL': 'RCT_EXPERIMENT_CONSENT:EDIT_ALL',
    'STUDENT_CONTRACT_STATUS:VIEW_ALL': 'STUDENT_CONTRACT_STATUS:VIEW_ALL',
    'STUDENT_CONTRACT_STATUS:EDIT_ALL': 'STUDENT_CONTRACT_STATUS:EDIT_ALL',
    'REVIEWER:VIEW': 'REVIEWER:VIEW',
    'REVIEWER:CREATE': 'REVIEWER:CREATE',
    'REVIEWER:EDIT': 'REVIEWER:EDIT',
    'USER_REVIEWER_RELATIONSHIP:EDIT': 'USER_REVIEWER_RELATIONSHIP:EDIT',
    VIEW_OTHER_SESSIONS_TAB: 'VIEW_OTHER_SESSIONS_TAB',
    EDIT_PREFERRED_PRONOUN: 'EDIT_PREFERRED_PRONOUN',
    'SYSTEM_ADMIN:VIEW': 'SYSTEM_ADMIN:VIEW',
    'SYSTEM_ADMIN:CREATE': 'SYSTEM_ADMIN:CREATE',
    'CGA_STAFF:VIEW': 'CGA_STAFF:VIEW',
    'CGA_STAFF:CREATE': 'CGA_STAFF:CREATE',
    'CGA_STUDENT_PROGRESS_REPORTS:VIEW': 'CGA_STUDENT_PROGRESS_REPORTS:VIEW',
    'HOOK_STATEMENT:EDIT': 'HOOK_STATEMENT:EDIT',
    'ESSAY_FOLDER:EDIT': 'ESSAY_FOLDER:EDIT',
    VIEW_CONTACTS: 'VIEW_CONTACTS',
};
exports.default = permissions;
//# sourceMappingURL=permissions.js.map